export const authCertificates = [
  {
    id: 'GF-AUTH-2026-0891',
    device: 'iPhone 15 Pro Max',
    color: 'Natural Titanium',
    storage: '256GB',
    imei: '352789104523671',
    imei2: '352789104523688',
    serialNumber: 'F4GTX9KQPN',
    condition: 'New',
    batteryHealth: 100,
    purchaseDate: 'Apr 22, 2026',
    customer: 'Kwame Mensah',
    soldBy: 'Ama Boateng',
    warrantyExpiry: 'Apr 22, 2027',
    verificationStatus: 'verified',
    imeiStatus: 'clean',
    activationLock: false,
    qrCode: 'https://gadgetflow.gh/verify/GF-AUTH-2026-0891',
  },
  {
    id: 'GF-AUTH-2026-0890',
    device: 'Samsung Galaxy S24 Ultra',
    color: 'Titanium Black',
    storage: '512GB',
    imei: '490123456789012',
    imei2: '490123456789029',
    serialNumber: 'R5CX8MNQWT',
    condition: 'New',
    batteryHealth: 100,
    purchaseDate: 'Apr 21, 2026',
    customer: 'Abena Osei',
    soldBy: 'Kofi Asante',
    warrantyExpiry: 'Apr 21, 2027',
    verificationStatus: 'verified',
    imeiStatus: 'clean',
    activationLock: false,
    qrCode: 'https://gadgetflow.gh/verify/GF-AUTH-2026-0890',
  },
  {
    id: 'GF-AUTH-2026-0889',
    device: 'MacBook Air M3',
    color: 'Midnight',
    storage: '512GB SSD',
    imei: 'N/A',
    imei2: 'N/A',
    serialNumber: 'C02XK9YZMD6T',
    condition: 'New',
    batteryHealth: 100,
    purchaseDate: 'Apr 20, 2026',
    customer: 'Kofi Agyeman',
    soldBy: 'Ama Boateng',
    warrantyExpiry: 'Apr 20, 2027',
    verificationStatus: 'verified',
    imeiStatus: 'N/A',
    activationLock: false,
    qrCode: 'https://gadgetflow.gh/verify/GF-AUTH-2026-0889',
  },
  {
    id: 'GF-AUTH-2026-0888',
    device: 'iPhone 14 Pro',
    color: 'Deep Purple',
    storage: '128GB',
    imei: '358901234567890',
    imei2: '358901234567907',
    serialNumber: 'H7YMN2QRST',
    condition: 'Refurbished',
    batteryHealth: 91,
    purchaseDate: 'Apr 19, 2026',
    customer: 'Ama Darko',
    soldBy: 'Yaw Mensah',
    warrantyExpiry: 'Apr 19, 2027',
    verificationStatus: 'verified',
    imeiStatus: 'clean',
    activationLock: false,
    qrCode: 'https://gadgetflow.gh/verify/GF-AUTH-2026-0888',
  },
  {
    id: 'GF-AUTH-2026-0887',
    device: 'Google Pixel 8 Pro',
    color: 'Bay',
    storage: '256GB',
    imei: '867123456789012',
    imei2: '867123456789029',
    serialNumber: 'G9PXL4MNQR',
    condition: 'New',
    batteryHealth: 100,
    purchaseDate: 'Apr 18, 2026',
    customer: 'Yaw Boateng',
    soldBy: 'Kofi Asante',
    warrantyExpiry: 'Apr 18, 2027',
    verificationStatus: 'verified',
    imeiStatus: 'clean',
    activationLock: false,
    qrCode: 'https://gadgetflow.gh/verify/GF-AUTH-2026-0887',
  },
];

export const imeiCheckHistory = [
  { imei: '352789104523671', device: 'iPhone 15 Pro Max', status: 'clean', checkedAt: '2m ago', network: 'Unlocked' },
  { imei: '490123456789012', device: 'Samsung S24 Ultra', status: 'clean', checkedAt: '15m ago', network: 'Unlocked' },
  { imei: '358901234567890', device: 'iPhone 14 Pro', status: 'clean', checkedAt: '1h ago', network: 'Unlocked' },
  { imei: '867123456789012', device: 'Google Pixel 8 Pro', status: 'clean', checkedAt: '2h ago', network: 'Unlocked' },
  { imei: '123456789012345', device: 'Unknown Device', status: 'flagged', checkedAt: '3h ago', network: 'Locked' },
];
